import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-secondary grid grid-cols-1 gap-3 rounded-md border p-5 sm:grid-cols-2" }
const _hoisted_2 = { class: "col-span-2 flex items-center justify-between gap-3" }
const _hoisted_3 = { class: "text-secondary text-xs" }
const _hoisted_4 = { class: "flex flex-col gap-3" }
const _hoisted_5 = { class: "flex flex-col gap-2" }
const _hoisted_6 = { class: "border-secondary flex flex-col gap-3 rounded-md border p-3" }

import { InputRow, MultiCombobox, Select, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import DeleteButton from '@/components/DeleteButton.vue';
    import { optionsDays, optionsYesNo } from '@/utils/form';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TaskTemplateTaskForm',
  props: {
    form: {},
    mainForm: {},
    index: {},
    keepersEmployees: {}
  },
  emits: ["remove"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;

    const emit = __emit;

    const removeTask = () => {
        emit('remove', props.index);
    };

    const statusOptions = [
        { value: 'Open', label: 'task-templates.statuses.Open' },
        { value: 'Finish', label: 'task-templates.statuses.Finish' },
        { value: 'Closed', label: 'task-templates.statuses.Closed' },
        { value: 'Recurring', label: 'task-templates.statuses.Recurring' },
    ];

    const frequencyOptions = [
        { value: 0, label: 'task-templates.frequency_options.0' },
        { value: 1, label: 'task-templates.frequency_options.1' },
        { value: 2, label: 'task-templates.frequency_options.2' },
        { value: 4, label: 'task-templates.frequency_options.4' },
    ];

    const oddOrEvenWeekOptions = [
        { value: 1, label: 'task-templates.odd_or_even_week_options.1' },
        { value: 0, label: 'task-templates.odd_or_even_week_options.0' },
    ];

    const startOrEndOfMonthOptions = [
        { value: 1, label: 'task-templates.start_or_end_month_options.1' },
        { value: 0, label: 'task-templates.start_or_end_month_options.0' },
    ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('task-templates.task.task')), 1),
      _createVNode(DeleteButton, {
        onClick: _withModifiers(removeTask, ["prevent"])
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(InputRow), {
        form: _ctx.mainForm,
        name: "title",
        label: "task-templates.task.title",
        "error-key": `tasks.${_ctx.index}.title`
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "title",
            modelValue: _ctx.form.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
            placeholder: _ctx.$t('task-templates.task.title')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form", "error-key"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.mainForm,
        name: "description",
        label: "task-templates.task.description",
        "error-key": `tasks.${_ctx.index}.description`
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Input), {
            id: "description",
            modelValue: _ctx.form.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.description) = $event)),
            placeholder: _ctx.$t('task-templates.task.description')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form", "error-key"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.mainForm,
        name: "weekdays",
        label: "task-templates.weekdays",
        "error-key": `tasks.${_ctx.index}.weekdays`
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MultiCombobox), {
            modelValue: _ctx.form.weekdays,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.weekdays) = $event)),
            options: _unref(optionsDays),
            translate: true,
            placeholder: _ctx.$t('task-templates.weekdays')
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]),
        _: 1
      }, 8, ["form", "error-key"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.mainForm,
        name: "status",
        label: "task-templates.task.status"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Select), {
            modelValue: _ctx.form.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.status) = $event)),
            options: statusOptions,
            translate: true,
            placeholder: _ctx.$t('task-templates.task.status')
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["form"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Label), null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('task-templates.task.task_notification')), 1)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(InputRow), {
          form: _ctx.mainForm,
          name: "send_notification",
          label: "task-templates.task.send_notification"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Select), {
              modelValue: _ctx.form.send_notification,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.send_notification) = $event)),
              options: _unref(optionsYesNo),
              translate: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_unref(InputRow), {
          form: _ctx.mainForm,
          name: "notification_recurring_week",
          label: "task-templates.task.notification_frequency",
          "error-key": `tasks.${_ctx.index}.notification_recurring_week`
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Select), {
              modelValue: _ctx.form.notification_recurring_week,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.notification_recurring_week) = $event)),
              options: frequencyOptions,
              translate: true
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["form", "error-key"]),
        (_ctx.form.notification_recurring_week === '2')
          ? (_openBlock(), _createBlock(_unref(InputRow), {
              key: 0,
              form: _ctx.mainForm,
              name: "notification_recurring_even_week",
              label: "task-templates.task.notification_odd_or_even_week"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _ctx.form.notification_recurring_even_week,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.notification_recurring_even_week) = $event)),
                  options: oddOrEvenWeekOptions,
                  translate: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["form"]))
          : _createCommentVNode("", true),
        (_ctx.form.notification_recurring_week === '4')
          ? (_openBlock(), _createBlock(_unref(InputRow), {
              key: 1,
              form: _ctx.mainForm,
              name: "notification_recurring_start_of_month",
              label: "task-templates.task.notification_start_or_end_month"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  modelValue: _ctx.form.notification_recurring_start_of_month,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.notification_recurring_start_of_month) = $event)),
                  options: startOrEndOfMonthOptions,
                  translate: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["form"]))
          : _createCommentVNode("", true),
        _createVNode(_unref(InputRow), {
          form: _ctx.mainForm,
          name: "responsible_id",
          label: "task-templates.responsible"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Combobox), {
              modelValue: _ctx.form.responsible_id,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.responsible_id) = $event)),
              options: _ctx.keepersEmployees,
              placeholder: _ctx.$t('task-templates.responsible'),
              loading: !_ctx.keepersEmployees.length,
              "label-by": "name",
              "value-by": "id"
            }, null, 8, ["modelValue", "options", "placeholder", "loading"])
          ]),
          _: 1
        }, 8, ["form"])
      ])
    ])
  ]))
}
}

})